import { useDesignerStore } from '../../stores';
import styles from './LaserModeIndicator.module.css';

export const LaserModeIndicator = () => {
  const laserOnly = useDesignerStore((state) => state.laserOnly);
  const printType = useDesignerStore((state) => state.printType);

  if (!laserOnly && printType !== 'laser') {
    return null;
  }

  return (
    <div className={styles.indicator}>
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2L12 6" />
        <path d="M12 18L12 22" />
        <path d="M4.93 4.93L7.76 7.76" />
        <path d="M16.24 16.24L19.07 19.07" />
        <path d="M2 12L6 12" />
        <path d="M18 12L22 12" />
        <path d="M4.93 19.07L7.76 16.24" />
        <path d="M16.24 7.76L19.07 4.93" />
        <circle cx="12" cy="12" r="4" />
      </svg>
      <span className={styles.text}>Laser Print Mode: Your design will print in white</span>
    </div>
  );
};
